module.exports = __webpack_public_path__ + "h5/img/shouyi.438c0497.png";